import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Image,
  useColorScheme,
  Dimensions,
  StyleSheet,
  FlatList,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const AchievementsScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const [activeTab, setActiveTab] = useState('已获得');
  const [activeCategoryFilter, setActiveCategoryFilter] = useState('all');
  const screenWidth = Dimensions.get('window').width;

  // 模拟用户数据
  const userData = {
    name: '张三',
    level: 12,
    exp: 1450,
    nextLevelExp: 2000,
    achievements: 18,
    completedAchievements: 8,
    completed: 8,
    points: 1250,
    rank: 156,
  };

  // 模拟已完成成就数据
  const completedAchievements = [
    {
      id: 'a1',
      title: '连续打卡30天',
      description: '连续30天记录健康数据',
      category: 'activity',
      image: 'https://via.placeholder.com/60',
      points: 100,
      rarity: 'common',
      dateCompleted: '2023年4月15日',
    },
    {
      id: 'a2',
      title: '营养均衡达人',
      description: '一周内每天的三大营养素比例合理',
      category: 'nutrition',
      image: 'https://via.placeholder.com/60',
      points: 150,
      rarity: 'rare',
      dateCompleted: '2023年3月28日',
    },
    {
      id: 'a3',
      title: '运动先锋',
      description: '累计完成15次运动记录',
      category: 'activity',
      image: 'https://via.placeholder.com/60',
      points: 100,
      rarity: 'uncommon',
      dateCompleted: '2023年4月2日',
    },
    {
      id: 'a8',
      title: '体重管理专家',
      description: '达成减重目标',
      category: 'weight',
      image: 'https://via.placeholder.com/60',
      points: 300,
      rarity: 'epic',
      dateCompleted: '2023年5月10日',
    },
  ];

  // 模拟进行中成就数据
  const lockedAchievements = [
    {
      id: 'a4',
      title: '水分摄入达标',
      description: '连续7天达到每日饮水目标',
      category: 'nutrition',
      image: 'https://via.placeholder.com/60',
      points: 80,
      rarity: 'common',
      progress: 57,
    },
    {
      id: 'a5',
      title: '早起达人',
      description: '连续5天在7点前起床',
      category: 'sleep',
      image: 'https://via.placeholder.com/60',
      points: 60,
      rarity: 'common',
      progress: 40,
    },
    {
      id: 'a6',
      title: '蔬果爱好者',
      description: '连续7天摄入至少500g蔬果',
      category: 'nutrition',
      image: 'https://via.placeholder.com/60',
      points: 100,
      rarity: 'uncommon',
      progress: 85,
    },
    {
      id: 'a7',
      title: '社交达人',
      description: '在社区发布10条动态',
      category: 'social',
      image: 'https://via.placeholder.com/60',
      points: 100,
      rarity: 'rare',
      progress: 70,
    },
  ];

  // 模拟热门挑战数据
  const popularAchievements = [
    {
      id: 'p1',
      title: '30天早睡早起',
      description: '连续30天在23点前睡觉，7点前起床',
      category: 'sleep',
      image: 'https://via.placeholder.com/60',
      points: 200,
      rarity: 'rare',
      completionRate: '32%',
    },
    {
      id: 'p2',
      title: '连续运动21天',
      description: '连续21天每天进行至少30分钟的运动',
      category: 'activity',
      image: 'https://via.placeholder.com/60',
      points: 180,
      rarity: 'uncommon',
      completionRate: '45%',
    },
    {
      id: 'p3',
      title: '低糖饮食挑战',
      description: '连续14天糖分摄入不超过25g',
      category: 'nutrition',
      image: 'https://via.placeholder.com/60',
      points: 150,
      rarity: 'epic',
      completionRate: '18%',
    },
    {
      id: 'p4',
      title: '10000步挑战',
      description: '连续30天每天步数达到10000步',
      category: 'activity',
      image: 'https://via.placeholder.com/60',
      points: 250,
      rarity: 'legendary',
      completionRate: '12%',
    },
  ];

  // 模拟徽章数据 - 修改为使用Ionicons
  const badges = [
    {
      id: 'b1',
      title: '坚持不懈',
      description: '连续打卡30天',
      iconName: 'calendar',
      iconColor: '#10b981',
      rarity: 'common',
      earned: true,
      earnedDate: '2023年4月15日',
    },
    {
      id: 'b2',
      title: '饮食均衡',
      description: '营养素摄入完美平衡',
      iconName: 'nutrition',
      iconColor: '#3b82f6', 
      rarity: 'rare',
      earned: true,
      earnedDate: '2023年3月28日',
    },
    {
      id: 'b3',
      title: '运动健将',
      description: '完成15次高强度运动',
      iconName: 'fitness',
      iconColor: '#ec4899',
      rarity: 'uncommon',
      earned: true,
      earnedDate: '2023年4月2日',
    },
    {
      id: 'b4',
      title: '减重达人',
      description: '成功完成减重目标',
      iconName: 'scale',
      iconColor: '#8b5cf6',
      rarity: 'epic',
      earned: true,
      earnedDate: '2023年5月10日',
    },
    {
      id: 'b5',
      title: '社区活跃者',
      description: '在社区积极互动',
      iconName: 'people',
      iconColor: '#6366f1',
      rarity: 'uncommon',
      earned: false,
    },
    {
      id: 'b6',
      title: '水分守护者',
      description: '长期保持充足水分摄入',
      iconName: 'water',
      iconColor: '#0ea5e9',
      rarity: 'common',
      earned: false,
    },
    {
      id: 'b7',
      title: '睡眠优化者',
      description: '保持健康的睡眠习惯',
      iconName: 'moon',
      iconColor: '#8b5cf6',
      rarity: 'rare',
      earned: false,
    },
    {
      id: 'b8',
      title: '健康全能王',
      description: '在所有健康维度都达到卓越标准',
      iconName: 'trophy',
      iconColor: '#f59e0b',
      rarity: 'legendary',
      earned: false,
    },
  ];

  // 分类数据
  const categories = [
    { id: 'all', name: '全部', icon: 'apps' },
    { id: 'activity', name: '活动', icon: 'fitness' },
    { id: 'nutrition', name: '营养', icon: 'nutrition' },
    { id: 'sleep', name: '睡眠', icon: 'moon' },
    { id: 'social', name: '社交', icon: 'people' },
    { id: 'weight', name: '体重', icon: 'scale' },
  ];

  // 获取已获得和未获得的徽章
  const earnedBadges = badges.filter(badge => badge.earned);
  const unearnedBadges = badges.filter(badge => !badge.earned);
  
  // 徽章大小计算
  const badgeSize = (screenWidth - 32) / 4; // 每行4个徽章

  // 根据当前选择的标签获取相应的成就数据
  const getCurrentAchievements = () => {
    switch (activeTab) {
      case '已获得':
        return completedAchievements;
      case '进行中':
        return lockedAchievements;
      case '热门挑战':
        return popularAchievements;
      default:
        return completedAchievements;
    }
  };

  // 过滤成就
  const filteredAchievements = getCurrentAchievements().filter(achievement => {
    return activeCategoryFilter === 'all' || achievement.category === activeCategoryFilter;
  });

  // 根据稀有度获取颜色
  const getRarityColor = (rarity) => {
    switch (rarity) {
      case 'legendary':
        return '#f59e0b';
      case 'epic':
        return '#8b5cf6';
      case 'rare':
        return '#3b82f6';
      case 'uncommon':
        return '#10b981';
      case 'common':
      default:
        return '#6b7280';
    }
  };

  // 根据稀有度获取样式
  const getRarityStyle = (rarity) => {
    switch (rarity) {
      case 'legendary':
        return {
          color: '#f59e0b',
          backgroundColor: 'rgba(245, 158, 11, 0.1)',
          borderColor: 'rgba(245, 158, 11, 0.3)',
          label: '传说级'
        };
      case 'epic':
        return {
          color: '#8b5cf6',
          backgroundColor: 'rgba(139, 92, 246, 0.1)',
          borderColor: 'rgba(139, 92, 246, 0.3)',
          label: '史诗级'
        };
      case 'rare':
        return {
          color: '#3b82f6',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          borderColor: 'rgba(59, 130, 246, 0.3)',
          label: '稀有'
        };
      case 'common':
      default:
        return {
          color: '#10b981',
          backgroundColor: 'rgba(16, 185, 129, 0.1)',
          borderColor: 'rgba(16, 185, 129, 0.3)',
          label: '普通'
        };
    }
  };

  // 渲染已获得的成就项
  const renderCompletedAchievement = ({ item }) => {
    const rarityStyle = getRarityStyle(item.rarity);
    
    return (
      <TouchableOpacity 
        style={[
          styles.achievementCard, 
          isDarkMode ? styles.cardDark : styles.cardLight
        ]}
        onPress={() => navigation.navigate('AchievementDetail', { achievementId: item.id })}
      >
        <View style={styles.achievementHeader}>
          <Image source={{ uri: item.image }} style={styles.achievementImage} />
          <View style={styles.achievementInfo}>
            <Text style={[styles.achievementTitle, isDarkMode && styles.textLight]}>{item.title}</Text>
            <Text style={[styles.achievementDescription, isDarkMode && styles.textLightSecondary]}>
              {item.description}
            </Text>
            <View style={styles.achievementMeta}>
              <View style={[styles.rarityTag, { backgroundColor: rarityStyle.backgroundColor, borderColor: rarityStyle.borderColor }]}>
                <Text style={[styles.rarityText, { color: rarityStyle.color }]}>{rarityStyle.label}</Text>
              </View>
              <Text style={[styles.pointsText, isDarkMode && styles.textLightSecondary]}>
                <Ionicons name="star" size={14} color={isDarkMode ? "#ddd" : "#f59e0b"} /> {item.points}点
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.completionInfo}>
          <Text style={[styles.completionDate, isDarkMode && styles.textLightSecondary]}>
            获得于: {item.dateCompleted}
          </Text>
          <Ionicons name="trophy" size={20} color={isDarkMode ? "#f59e0b" : "#f59e0b"} />
        </View>
      </TouchableOpacity>
    );
  };

  // 渲染未解锁的成就项
  const renderLockedAchievement = ({ item }) => {
    const rarityStyle = getRarityStyle(item.rarity);
    
    return (
      <TouchableOpacity 
        style={[
          styles.achievementCard, 
          isDarkMode ? styles.cardDark : styles.cardLight
        ]}
        onPress={() => navigation.navigate('AchievementDetail', { achievementId: item.id })}
      >
        <View style={styles.achievementHeader}>
          <Image 
            source={{ uri: item.image }} 
            style={[
              styles.achievementImage, 
              { opacity: 0.6 }
            ]} 
          />
          <View style={styles.achievementInfo}>
            <Text style={[styles.achievementTitle, isDarkMode && styles.textLight]}>{item.title}</Text>
            <Text style={[styles.achievementDescription, isDarkMode && styles.textLightSecondary]}>
              {item.description}
            </Text>
            <View style={styles.achievementMeta}>
              <View style={[styles.rarityTag, { backgroundColor: rarityStyle.backgroundColor, borderColor: rarityStyle.borderColor }]}>
                <Text style={[styles.rarityText, { color: rarityStyle.color }]}>{rarityStyle.label}</Text>
              </View>
              <Text style={[styles.pointsText, isDarkMode && styles.textLightSecondary]}>
                <Ionicons name="star" size={14} color={isDarkMode ? "#ddd" : "#f59e0b"} /> {item.points}点
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.progressContainer}>
          <View style={styles.progressBarBackground}>
            <View 
              style={[
                styles.progressBarFill,
                { width: `${item.progress}%`, backgroundColor: rarityStyle.color }
              ]} 
            />
          </View>
          <Text style={[styles.progressText, isDarkMode && styles.textLightSecondary]}>
            进度: {item.progress}%
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  // 渲染热门成就项
  const renderPopularAchievement = ({ item }) => {
    const rarityStyle = getRarityStyle(item.rarity);
    
    return (
      <TouchableOpacity 
        style={[
          styles.achievementCard, 
          isDarkMode ? styles.cardDark : styles.cardLight
        ]}
        onPress={() => navigation.navigate('AchievementDetail', { achievementId: item.id })}
      >
        <View style={styles.achievementHeader}>
          <Image source={{ uri: item.image }} style={styles.achievementImage} />
          <View style={styles.achievementInfo}>
            <Text style={[styles.achievementTitle, isDarkMode && styles.textLight]}>{item.title}</Text>
            <Text style={[styles.achievementDescription, isDarkMode && styles.textLightSecondary]}>
              {item.description}
            </Text>
            <View style={styles.achievementMeta}>
              <View style={[styles.rarityTag, { backgroundColor: rarityStyle.backgroundColor, borderColor: rarityStyle.borderColor }]}>
                <Text style={[styles.rarityText, { color: rarityStyle.color }]}>{rarityStyle.label}</Text>
              </View>
              <Text style={[styles.pointsText, isDarkMode && styles.textLightSecondary]}>
                <Ionicons name="star" size={14} color={isDarkMode ? "#ddd" : "#f59e0b"} /> {item.points}点
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.completionInfo}>
          <Text style={[styles.completionDate, isDarkMode && styles.textLightSecondary]}>
            完成率: {item.completionRate}
          </Text>
          <TouchableOpacity style={styles.challengeButton}>
            <Text style={styles.challengeButtonText}>接受挑战</Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // 渲染经验条
  const renderExpBar = () => {
    const progress = (userData.exp / userData.nextLevelExp) * 100;
    
    return (
      <View style={{ marginBottom: 20 }}>
        <View style={{ 
          flexDirection: 'row', 
          justifyContent: 'space-between',
          marginBottom: 4,
        }}>
          <Text style={{ 
            fontSize: 14, 
            color: isDarkMode ? '#d1d5db' : '#6b7280',
          }}>
            等级 {userData.level}
          </Text>
          <Text style={{ 
            fontSize: 14, 
            color: isDarkMode ? '#d1d5db' : '#6b7280',
          }}>
            {userData.exp}/{userData.nextLevelExp}
          </Text>
        </View>
        <View style={{
          height: 8,
          backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
          borderRadius: 4,
          overflow: 'hidden',
        }}>
          <View style={{
            width: `${progress}%`,
            height: '100%',
            backgroundColor: '#2563eb',
            borderRadius: 4,
          }} />
        </View>
      </View>
    );
  };

  // 渲染用户信息卡片
  const renderUserCard = () => {
    return (
      <View style={{ 
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 16,
        padding: 16,
        marginBottom: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <View style={{ 
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 16,
        }}>
          <View style={{
            width: 60,
            height: 60,
            borderRadius: 30,
            backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 16,
          }}>
            <Text style={{
              fontSize: 24,
              fontWeight: 'bold',
              color: '#2563eb',
            }}>
              {userData.level}
            </Text>
          </View>
          <View>
            <Text style={{ 
              fontSize: 18,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {userData.name}
            </Text>
            <Text style={{ 
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              排名: #{userData.rank}
            </Text>
          </View>
          <View style={{ flex: 1, alignItems: 'flex-end' }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
              paddingHorizontal: 12,
              paddingVertical: 6,
              borderRadius: 20,
            }}>
              <Ionicons name="star" size={16} color="#f59e0b" style={{ marginRight: 6 }} />
              <Text style={{ 
                color: isDarkMode ? 'white' : '#1f2937',
                fontWeight: 'bold',
              }}>
                {userData.points} 积分
              </Text>
            </View>
          </View>
        </View>

        {/* 经验条 */}
        {renderExpBar()}

        {/* 成就统计 */}
        <View style={{ 
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
          <View style={{ alignItems: 'center' }}>
            <Text style={{ 
              fontSize: 20,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {userData.achievements}
            </Text>
            <Text style={{ 
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              总成就
            </Text>
          </View>
          <View style={{ alignItems: 'center' }}>
            <Text style={{ 
              fontSize: 20,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {userData.completedAchievements}
            </Text>
            <Text style={{ 
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              已完成
            </Text>
          </View>
          <View style={{ alignItems: 'center' }}>
            <Text style={{ 
              fontSize: 20,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {(userData.completedAchievements / userData.achievements * 100).toFixed(0)}%
            </Text>
            <Text style={{ 
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              完成率
            </Text>
          </View>
        </View>
      </View>
    );
  };

  // 渲染分类选择
  const renderCategories = () => {
    return (
      <ScrollView 
        horizontal 
        showsHorizontalScrollIndicator={false}
        style={{ marginBottom: 16 }}
      >
        {categories.map((category) => (
          <TouchableOpacity
            key={category.id}
            style={{
              alignItems: 'center',
              marginRight: 16,
              opacity: activeCategoryFilter === category.id ? 1 : 0.6,
            }}
            onPress={() => setActiveCategoryFilter(category.id)}
          >
            <View style={{
              width: 50,
              height: 50,
              borderRadius: 25,
              backgroundColor: activeCategoryFilter === category.id 
                ? (isDarkMode ? '#2563eb' : '#3b82f6') 
                : (isDarkMode ? '#374151' : '#f3f4f6'),
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 8,
            }}>
              <Ionicons 
                name={category.icon} 
                size={24} 
                color={activeCategoryFilter === category.id ? 'white' : (isDarkMode ? '#9ca3af' : '#6b7280')} 
              />
            </View>
            <Text style={{
              fontSize: 12,
              fontWeight: activeCategoryFilter === category.id ? 'bold' : 'normal',
              color: isDarkMode ? 'white' : '#1f2937',
            }}>
              {category.name}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    );
  };

  // 渲染徽章部分
  const renderBadgesSection = () => {
    return (
      <View style={{ 
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 16,
        padding: 16,
        marginBottom: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <View style={{ 
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}>
          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
          }}>
            我的徽章
          </Text>
          <TouchableOpacity
            style={{ flexDirection: 'row', alignItems: 'center' }}
            onPress={() => alert('徽章系统将在未来版本中完善')}
          >
            <Text style={{ color: '#3b82f6', marginRight: 4 }}>
              查看全部
            </Text>
            <Ionicons name="chevron-forward" size={16} color="#3b82f6" />
          </TouchableOpacity>
        </View>
        
        <View style={{ marginBottom: 16 }}>
          <Text style={{ 
            fontSize: 14,
            color: isDarkMode ? '#d1d5db' : '#6b7280',
            marginBottom: 12,
          }}>
            已获得的徽章
          </Text>
          <View style={{ 
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}>
            {earnedBadges.map(badge => (
              <TouchableOpacity
                key={badge.id}
                style={{
                  width: badgeSize,
                  alignItems: 'center',
                  marginBottom: 16,
                }}
                onPress={() => alert(`${badge.title}: ${badge.description}`)}
              >
                <View style={{
                  width: badgeSize - 16,
                  height: badgeSize - 16,
                  borderRadius: (badgeSize - 16) / 2,
                  backgroundColor: isDarkMode ? '#374151' : 'white',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 8,
                  shadowColor: getRarityColor(badge.rarity),
                  shadowOffset: { width: 0, height: 0 },
                  shadowOpacity: 0.3,
                  shadowRadius: 8,
                  elevation: 4,
                }}>
                  <Ionicons 
                    name={badge.iconName} 
                    size={badgeSize - 40} 
                    color={badge.iconColor}
                  />
                </View>
                <Text style={{
                  fontSize: 12,
                  fontWeight: 'bold',
                  color: getRarityColor(badge.rarity),
                  textAlign: 'center',
                }}>
                  {badge.title}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
        
        {unearnedBadges.length > 0 && (
          <View>
            <Text style={{ 
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
              marginBottom: 12,
            }}>
              未获得的徽章
            </Text>
            <View style={{ 
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}>
              {unearnedBadges.slice(0, 4).map(badge => (
                <TouchableOpacity
                  key={badge.id}
                  style={{
                    width: badgeSize,
                    alignItems: 'center',
                    marginBottom: 16,
                    opacity: 0.5,
                  }}
                  onPress={() => alert(`获取方式: 完成相关成就可解锁此徽章`)}
                >
                  <View style={{
                    width: badgeSize - 16,
                    height: badgeSize - 16,
                    borderRadius: (badgeSize - 16) / 2,
                    backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: 8,
                  }}>
                    <Ionicons name="lock-closed" size={24} color={isDarkMode ? '#9ca3af' : '#9ca3af'} />
                  </View>
                  <Text style={{
                    fontSize: 12,
                    color: isDarkMode ? '#9ca3af' : '#9ca3af',
                    textAlign: 'center',
                  }}>
                    {badge.title}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        )}
      </View>
    );
  };

  return (
    <View style={[
      styles.container,
      isDarkMode ? styles.containerDark : styles.containerLight
    ]}>
      <ScrollView style={{ padding: 16 }}>
        {/* 用户信息卡片 */}
        {renderUserCard()}
        
        {/* 徽章部分 */}
        {renderBadgesSection()}
        
        {/* 成就部分 */}
        <Text style={{ 
          fontSize: 18,
          fontWeight: 'bold',
          color: isDarkMode ? 'white' : '#1f2937',
          marginBottom: 16,
        }}>
          我的成就
        </Text>
        
        {/* 分类选择 */}
        {renderCategories()}
        
        {/* 成就统计卡片 */}
        <View style={[
          styles.statsCard,
          isDarkMode ? styles.cardDark : styles.cardLight
        ]}>
          <View style={styles.statsHeader}>
            <View>
              <Text style={[styles.statsTitle, isDarkMode && styles.textLight]}>成就进度</Text>
              <Text style={[styles.statsSubtitle, isDarkMode && styles.textLightSecondary]}>
                继续保持，解锁更多成就！
              </Text>
            </View>
            <View style={styles.levelContainer}>
              <Text style={styles.levelNumber}>{userData.level}</Text>
              <Text style={styles.levelLabel}>级别</Text>
            </View>
          </View>
          
          <View style={styles.statsRow}>
            <View style={styles.statItem}>
              <Text style={[styles.statNumber, isDarkMode && styles.textLight]}>{userData.completed}</Text>
              <Text style={[styles.statLabel, isDarkMode && styles.textLightSecondary]}>已获得</Text>
            </View>
            <View style={styles.statItem}>
              <Text style={[styles.statNumber, isDarkMode && styles.textLight]}>{userData.achievements}</Text>
              <Text style={[styles.statLabel, isDarkMode && styles.textLightSecondary]}>总成就</Text>
            </View>
            <View style={styles.statItem}>
              <Text style={[styles.statNumber, isDarkMode && styles.textLight]}>{userData.points}</Text>
              <Text style={[styles.statLabel, isDarkMode && styles.textLightSecondary]}>积分</Text>
            </View>
          </View>
          
          <View style={styles.levelProgressContainer}>
            <Text style={[styles.levelProgressText, isDarkMode && styles.textLightSecondary]}>
              距离下一级别还需 {userData.nextLevelExp - userData.exp} 经验
            </Text>
            <View style={styles.levelProgressBar}>
              <View 
                style={[
                  styles.levelProgressFill,
                  { width: `${(userData.exp / userData.nextLevelExp) * 100}%` }
                ]} 
              />
            </View>
          </View>
        </View>
        
        {/* 标签栏 */}
        <View style={styles.tabBar}>
          {['已获得', '进行中', '热门挑战'].map((tab) => (
            <TouchableOpacity
              key={tab}
              style={[
                styles.tab,
                activeTab === tab && styles.activeTab,
                activeTab === tab && isDarkMode && styles.activeTabDark
              ]}
              onPress={() => setActiveTab(tab)}
            >
              <Text
                style={[
                  styles.tabText,
                  activeTab === tab && styles.activeTabText,
                  isDarkMode && styles.textLight,
                  activeTab === tab && isDarkMode && styles.activeTabTextDark
                ]}
              >
                {tab}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
        
        {/* 内容区域 */}
        <View style={styles.content}>
          {activeTab === '已获得' && (
            <FlatList
              data={completedAchievements}
              renderItem={renderCompletedAchievement}
              keyExtractor={(item) => item.id}
              scrollEnabled={false}
            />
          )}
          
          {activeTab === '进行中' && (
            <FlatList
              data={lockedAchievements}
              renderItem={renderLockedAchievement}
              keyExtractor={(item) => item.id}
              scrollEnabled={false}
            />
          )}
          
          {activeTab === '热门挑战' && (
            <FlatList
              data={popularAchievements}
              renderItem={renderPopularAchievement}
              keyExtractor={(item) => item.id}
              scrollEnabled={false}
            />
          )}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  containerLight: {
    backgroundColor: '#f5f5f5',
  },
  containerDark: {
    backgroundColor: '#121212',
  },
  textLight: {
    color: '#f5f5f5',
  },
  textLightSecondary: {
    color: '#aaa',
  },
  statsCard: {
    borderRadius: 16,
    padding: 16,
    marginBottom: 20,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  cardLight: {
    backgroundColor: '#fff',
  },
  cardDark: {
    backgroundColor: '#2a2a2a',
  },
  statsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  statsTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  statsSubtitle: {
    fontSize: 14,
    color: '#777',
    marginTop: 2,
  },
  levelContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: '#4CAF50',
    justifyContent: 'center',
    alignItems: 'center',
  },
  levelNumber: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
  },
  levelLabel: {
    color: '#fff',
    fontSize: 10,
  },
  statsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
  },
  statItem: {
    alignItems: 'center',
  },
  statNumber: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
  statLabel: {
    fontSize: 12,
    color: '#777',
    marginTop: 2,
  },
  levelProgressContainer: {
    marginTop: 8,
  },
  levelProgressText: {
    fontSize: 12,
    color: '#777',
    marginBottom: 6,
    textAlign: 'center',
  },
  levelProgressBar: {
    height: 8,
    backgroundColor: '#eee',
    borderRadius: 4,
    overflow: 'hidden',
  },
  levelProgressFill: {
    height: '100%',
    backgroundColor: '#4CAF50',
    borderRadius: 4,
  },
  tabBar: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  tab: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
  },
  activeTab: {
    borderBottomColor: '#4CAF50',
  },
  activeTabDark: {
    borderBottomColor: '#81C784',
  },
  tabText: {
    fontSize: 15,
    fontWeight: '500',
    color: '#777',
  },
  activeTabText: {
    color: '#4CAF50',
    fontWeight: 'bold',
  },
  activeTabTextDark: {
    color: '#81C784',
  },
  content: {
    flex: 1,
  },
  achievementCard: {
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  achievementHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  achievementImage: {
    width: 60,
    height: 60,
    borderRadius: 8,
    marginRight: 12,
  },
  achievementInfo: {
    flex: 1,
    justifyContent: 'center',
  },
  achievementTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  achievementDescription: {
    fontSize: 14,
    color: '#666',
    marginBottom: 8,
    lineHeight: 18,
  },
  achievementMeta: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rarityTag: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    borderWidth: 1,
  },
  rarityText: {
    fontSize: 12,
    fontWeight: '500',
  },
  pointsText: {
    fontSize: 13,
    color: '#666',
  },
  completionInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingTop: 12,
    marginTop: 8,
  },
  completionDate: {
    fontSize: 13,
    color: '#777',
  },
  progressContainer: {
    marginTop: 8,
  },
  progressBarBackground: {
    height: 8,
    backgroundColor: '#eee',
    borderRadius: 4,
    overflow: 'hidden',
    marginBottom: 6,
  },
  progressBarFill: {
    height: '100%',
    borderRadius: 4,
  },
  progressText: {
    fontSize: 13,
    color: '#777',
    textAlign: 'right',
  },
  challengeButton: {
    backgroundColor: '#4CAF50',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 4,
  },
  challengeButtonText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '500',
  },
});

export default AchievementsScreen; 